import { NgModule, ModuleWithProviders, Inject, LOCALE_ID } from '@angular/core';
import { GSPMetadataService } from './metadata.service';
import { HttpClient } from '@angular/common/http';
import { GSP } from '@farris/ide-devkit';

export function factory(http: HttpClient, url: string) {
  return new GSPMetadataService(http, url);
}

@NgModule({
  exports: [],
  providers: []
})
export class GSPMetadataServiceModule {
  static forRoot(url: string): ModuleWithProviders {
    return {
      ngModule: GSPMetadataServiceModule,
      providers: [
        {provide: 'url', useValue: url},
        {provide: GSPMetadataService, useFactory: factory, deps: [HttpClient, 'url']},
        {provide: LOCALE_ID,  useValue: localStorage.getItem('languageCode') || 'zh-CHS' }
      ]
    };
  }
}

declare global {
  var gsp: GSP;
}

const globalGsp = (window.top as any).gsp;
if (!(window as any).gsp) {
  (window as any).gsp = /*(globalGsp && globalGsp.createChild()) ||*/ new GSP(globalGsp);
}
